// services/everpro/everpro-auth.ts — Everpro client PER-BRAND via S2 proxy
// Semua call → `${getApiUrl()}/api/everpro/{brandId}/{path}` (S2 resolve credential brand,
// token di-cache server-side). Secret TIDAK pernah masuk bundle browser.

import { getApiUrl, API_KEY } from '../apiConfig';
import { backendHeaders } from '../apiAuth';

export const EVERPRO_BASE = '/everpro-proxy'; // legacy — jangan dipakai lagi

export async function everproFetch(brandId: string, path: string, init?: RequestInit): Promise<Response> {
  const base: Record<string, string> = {};
  (new Headers(init?.headers || {})).forEach((v, k) => { base[k] = v; });
  const headers = new Headers(await backendHeaders(base, API_KEY));
  if (init?.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const url = `${getApiUrl()}/api/everpro/${encodeURIComponent(brandId)}${path}`;
  return fetch(url, { ...init, headers });
}
